module.exports = __webpack_public_path__ + "static/digital-titan-mag-a8861a35e2f559d31bddbfd37e659563.jpg";